(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["og26-product-videos"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.og23-product-video').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) details.querySelector('video')?.pause();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
